import React, { useState } from "react";
import "../../style/treeCheckbox.css"; 

const treeData = [
  {
    id: "bs_1",
    label: "Main Level 1",
    children: [
      {
        id: "bf_1",
        label: "Sub Level 1",
        children: [
          { id: "io_1", label: "Last Level 1" },
          { id: "io_2", label: "Last Level 2" },
          { id: "io_3", label: "Last Level 3" },
          { id: "io_4", label: "Last Level 4" },
        ],
      },
      {
        id: "bf_2",
        label: "Sub Level 2",
        children: [
          { id: "io_5", label: "Last Level 5" },
          { id: "io_6", label: "Last Level 6" },
          { id: "io_7", label: "Last Level 7" },
          { id: "io_8", label: "Last Level 8" },
        ],
      },
    ],
  },
  {
    id: "bs_2",
    label: "Main Level 2",
    children: [
      {
        id: "bf_3",
        label: "Sub Level 3",
        children: [
          { id: "io_9", label: "Last Level 9" },
          { id: "io_10", label: "Last Level 10" },
          { id: "io_11", label: "Last Level 11" },
          { id: "io_12", label: "Last Level 12" },
        ],
      },
      {
        id: "bf_4",
        label: "Sub Level 4",
        children: [
          { id: "io_13", label: "Last Level 13" },
          { id: "io_14", label: "Last Level 14" },
          { id: "io_15", label: "Last Level 15" },
          { id: "io_16", label: "Last Level 16" },
        ],
      },
    ],
  },
];

const TreeNode = ({ node }) => {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const toggleOpen = () => setOpen(!open);
  const toggleCheck = () => setChecked(!checked);

  return (
    <li>
      <div className="checkbox-tree-node">
        {node.children && (
          <span className={`plus ${open ? "open" : ""}`} onClick={toggleOpen}>
            {open ? "-" : "+"}
          </span>
        )}
        <input type="checkbox" checked={checked} onChange={toggleCheck} />
        <span>{node.label}</span>
      </div>
      {node.children && open && (
        <ul className="inner_ul">
          {node.children.map((child) => (
            <TreeNode key={child.id} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
};
export default function CheckboxTree() {
  return (
    <div className="checkbox-tree-page full-width">
      <h1 className="mb-3 fw-normal border-bottom pb-2 mb-4">Check Box</h1>
      <div className="checkbox_tree_main">
        <ul className="main_ul">
          {treeData.map((node) => (
            <TreeNode key={node.id} node={node} />
          ))}
        </ul>
      </div>
    </div>
  );
}